/* eslint-disable max-len */
import 'react';

const ExternalSharingMenuSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_209_292510" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
            <rect width="18" height="18" transform="matrix(1 -8.7836e-08 -8.7836e-08 -1 0 18)" fill="#FF0606" />
        </mask>
        <g mask="url(#mask0_209_292510)">
            <path d="M9 15.5625C12.6244 15.5625 15.5625 12.6244 15.5625 9C15.5625 5.37563 12.6244 2.4375 9 2.4375C5.37563 2.4375 2.4375 5.37563 2.4375 9C2.4375 12.6244 5.37563 15.5625 9 15.5625Z" stroke="#39404D" strokeWidth="1.125" />
            <path d="M8.99977 15.2949C10.7072 15.2949 12.0913 12.4766 12.0913 9C12.0913 5.52341 10.7072 2.70508 8.99977 2.70508C7.29234 2.70508 5.9082 5.52341 5.9082 9C5.9082 12.4766 7.29234 15.2949 8.99977 15.2949Z" stroke="#39404D" strokeWidth="0.96" />
            <path d="M2.4375 9C2.4375 9.61852 5.37563 10.1199 9 10.1199C12.6244 10.1199 15.5625 9.61852 15.5625 9" stroke="#39404D" strokeWidth="0.96" />
        </g>
    </svg>
);
export default ExternalSharingMenuSvg;
